import moment from "moment";
import _ from "lodash";
import { JOB_ROLE } from "constants/options";
import { sortNoteLatest,sortOldest } from "utils/utils";
import { DATE_OLDEST_TO_NEWEST } from "constants/options";
import {
  REFRESH_MILESTONES,
  GET_MILESTONES,
  SET_FEATURED_MILESTONE,
  SET_CURRENT_MILESTONES,
  SET_PAST_MILESTONES,
  SET_UPCOMING_MILESTONES,
  SET_IS_FEATURED,
  SET_ORGANIZE_BY,
  SET_JOB_ROLE,
  SET_MILESTONES,
  SET_CATEGORY,
  SET_FILTERS,
  CLEAR_FILTERS,
  ADD_MILESTONES,
  UPDATE_MILESTONES,
  UPDATE_CURRENT_MILESTONE,
  UPDATE_PAST_MILESTONE,
  UPDATE_FEATURED_MILESTONE,
  DELETE_MILESTONE,
  FINISH_GET_MILESTONES,
  SET_PINNED_MILESTONES,
  SET_TAGGED_MILESTONES,
  SET_PLAY_MUSIC,
  UPDATE_PINNED_MILESTONES,
  UPDATE_TAGGED_MILESTONES,
  UPDATE_UPCOMING_MILESTONE,
  SET_SORT,
  SET_CUSTOMORDER_JR,
  SET_CUSTOMORDER_CAT,
  SET_MILESTONES_SEARCHTEXT,
  REFRESH_MILESTONES_PINNED,
  SET_LOADING_TRANSLATE,
  SET_BUTTON_COUNT,
  EMPTY_TAGGED_MILESTONES,
  REMOVE_TAGGED_MILESTONES,
  DELETE_MILESTONE_ORG
} from "./types";
import { DATE_NEWEST_TO_OLDEST, DATE } from "constants/options";
import { compareDate } from "utils/utils";

const initialState = {
  refresh: false,
  loadMore: false,
  initialize: false,
  featured: false,
  organizeBy: null,
  jobRole: [],
  category: [],
  limit: 30,
  total: 0,
  isRequesting: false,
  featuredMilestone: {},
  currentMilestones: [],
  pastMilestones: [],
  pinnedMilestones:[],
  upcomingMilestones:[],
  taggedMilestones: [],
  milestones: [],
  buttonCount: 0,
  playMusic: null,
  sort:null,
  customOrderJR:[],
  customOrderCAT:[],
  milestonesSearchtext: "",
  loadingTranslate:false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REFRESH_MILESTONES:
      return {
        ...state,
        refresh: false,
        loadMore: false,
        initialize: true,
        isRequesting: false,
        total: 0,
        featuredMilestone: {},
        currentMilestones: [],
        pastMilestones: [],
        milestones: [],
        taggedMilestones: [],
        // pinnedMilestones:[],
        upcomingMilestones:[],
        dontFetch:false
      };
    
    case REFRESH_MILESTONES_PINNED:
        return {
          ...state,
          loadMore:false,
          dontFetch:false,
          pinnedMilestones:[],
        };

    case GET_MILESTONES:
      return {
        ...state,
        isRequesting: true,
      };

    case FINISH_GET_MILESTONES:
      return {
        ...state,
        isRequesting: false,
        loadMore: payload.loadMore,
        dontFetch:!payload.loadMore //opposite of load more return
      };

    case SET_FEATURED_MILESTONE:
      return {
        ...state,
        featuredMilestone: payload,
      };
      
    case SET_CURRENT_MILESTONES:
      let newCurrentMilestones = state.currentMilestones;

      payload.data.forEach((m) => {
        const milestone = state.currentMilestones.filter(
          (cm) => cm.position_id === m.position_id && cm.id === m.id
        );
        if (!milestone.length) {
          newCurrentMilestones.push(m);
        }
      });

      return {
        ...state,
        refresh: false,
        initialize: false,
        total: payload.total,
        currentMilestones: newCurrentMilestones,
      };

    case SET_UPCOMING_MILESTONES:
      let newUpcomingMilestones = state.upcomingMilestones;
      payload.data.forEach((m) => {
        const milestone = state.upcomingMilestones.filter(
          (cm) => cm.position_id === m.position_id && cm.id === m.id
        );
        if (!milestone.length) {
          newUpcomingMilestones.push(m);
        }
      });

      return {
        ...state,
        refresh: false,
        initialize: false,
        total: payload.total,
        upcomingMilestones: newUpcomingMilestones,
      };

    case SET_PAST_MILESTONES:
      const newPastMilestones = state.pastMilestones;

      payload.data.forEach((m) => {
        const milestone = state.pastMilestones.filter(
          (pm) => pm.position_id === m.position_id && pm.id === m.id
        );
        if (!milestone.length) {
          newPastMilestones.push(m);
        }
      });

      return {
        ...state,
        refresh: false,
        initialize: false,
        total: payload.total,
        pastMilestones: newPastMilestones,
      };

    case SET_PINNED_MILESTONES:
      const newPinnedMilestones = state.pinnedMilestones;

      payload.data.forEach((m) => {
        const milestone = state.pinnedMilestones.filter(
          (pm) => pm.position_id === m.position_id && pm.id === m.id
        );
        if (!milestone.length) {
          newPinnedMilestones.push(m);
        }
      });

      return {
        ...state,
        refresh: false,
        initialize: false,
        total: payload.total,
        pinnedMilestones: newPinnedMilestones,
      };

    case REMOVE_TAGGED_MILESTONES:
      return {
        ...state,
        refresh: false,
        initialize: false,
        total: payload.total,
        taggedMilestones: payload.data,
      };

    case SET_TAGGED_MILESTONES:
      const newTaggedMilestones = state.taggedMilestones;
 
      payload.data.forEach((m) => {
        const milestone = state.taggedMilestones.filter(
          (tm) => tm.position_id === m.position_id && tm.id === m.id
        );
        if (!milestone.length) {
          newTaggedMilestones.push(m);
        }
      });

      return {
        ...state,
        refresh: false,
        initialize: false,
        total: payload.total,
        taggedMilestones: newTaggedMilestones,
      };

    case UPDATE_TAGGED_MILESTONES:
      let taggedMilestoneList = state.taggedMilestones;
      console.log('UPDATE_TAGGED_MILESTONES action called with payload:', payload);

      console.log('payload.data :', payload.data);
      console.log('taggedMilestoneList :', taggedMilestoneList);

      state.taggedMilestones.forEach((cm, index) => {
        if (cm.id === payload.data.id) {
          taggedMilestoneList[index] = {
            ...cm,
            ...payload.data,
          };
        }
      });


      return {
        ...state,
        taggedMilestones: taggedMilestoneList
      };

    case EMPTY_TAGGED_MILESTONES:
      return {
        ...state,
        taggedMilestones: []
      };


    case UPDATE_PINNED_MILESTONES:
      let currentPinnedMilestoneList = state.pinnedMilestones;
      let current_milestones = state.currentMilestones;
      let past_milestone_pin = state.pastMilestones;
      let upcoming_milestone_pin = state.upcomingMilestones;
      currentPinnedMilestoneList.forEach((cpm, index) => {
        const payloadArray = Array.isArray(payload.data) ? payload.data : [payload.data];
        console.log('payloadArray :', payloadArray);
        payloadArray.forEach(item => {
          if (cpm.id === item.id) {
            item.start_date = `${item?.start_year}-${item?.start_month || 12}-${item?.start_day || 31}`
            currentPinnedMilestoneList[index] = {
              ...cpm,
              ...item,
            };
          }
        });
       
      });
      currentPinnedMilestoneList = currentPinnedMilestoneList.filter(pinned => pinned.is_featured === 1); //removed if unpinned the milestone in edit
      if(payload.data[0].is_featured === 0){ // I assumed that this is only 1 array since the return from response is object and converted to array.
        // let currentYear = new Date().getFullYear();
        // if(payload.data[0].is_present === 1 || payload.data[0].end_year === currentYear){
        //     current_milestones = [...current_milestones, ...payload.data];
        // }else{
        //     past_milestone_pin = [...past_milestone_pin, ...payload.data];
        // }
        console.log(payload.data)
        if (compareDate(payload.data[0]) === 'upcoming') {
            upcoming_milestone_pin = [...upcoming_milestone_pin, ...payload.data].sort((a, b) => new Date(b.start_date) - new Date(a.start_date))
        } else if (compareDate(payload.data[0]) === 'current') {
            current_milestones = [...current_milestones, ...payload.data].sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
        } else if (compareDate(payload.data[0]) === 'past') {
            past_milestone_pin = [...past_milestone_pin, ...payload.data].sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
        }
      }
      return {
        ...state,
        // pinnedMilestones: state.sort === DATE_OLDEST_TO_NEWEST ? sortOldest(currentPinnedMilestoneList) : sortNoteLatest(currentPinnedMilestoneList),
        pinnedMilestones: currentPinnedMilestoneList.sort((a,b)=>a.order - b.order),
        currentMilestones: current_milestones,
        pastMilestones: past_milestone_pin,
        upcomingMilestones: upcoming_milestone_pin,
      };

    case UPDATE_UPCOMING_MILESTONE:
      let upcoming_milestones = state.upcomingMilestones;
      let pin_in_upcoming = state.pinnedMilestones;
      let current_in_upcoming = state.currentMilestones;
      let past_in_upcoming = state.pastMilestones;
      state.upcomingMilestones.forEach((cpm, index) => {
        // const payloadArray = Array.isArray(payload.data) ? payload.data : [payload.data];
        // payloadArray.forEach(item => {
          if (cpm.id === payload.data.id) {
            payload.data.start_date = `${payload.data?.start_year}-${payload.data?.start_month || 12}-${payload.data?.start_day || 31}`
            upcoming_milestones[index] = {
              ...cpm,
              ...payload.data,
            };
          }
        // });
       
      });
      upcoming_milestones = upcoming_milestones.filter(pinned => pinned.is_featured === 0); //removed if unpinned the milestone in edit

      if(payload.data.is_featured === 1){ // I assumed that this is only 1 array since the return from response is object and converted to array.
        pin_in_upcoming = [...pin_in_upcoming, ...[payload.data]].sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
      }else{// when the date was changed and rearrange based on the event (upcoming,curren and past)
        if (compareDate(payload.data) === 'current') {
          current_in_upcoming = [...current_in_upcoming, ...[payload.data]].sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
          upcoming_milestones = upcoming_milestones.filter(um => um.id !== payload.data.id);
        }  
        else if (compareDate(payload.data) === 'past') {
          upcoming_milestones = upcoming_milestones.filter(um => um.id !== payload.data.id);
          past_in_upcoming = [...past_in_upcoming, ...[payload.data]].sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
        }
      }
      return {
        ...state,
        upcomingMilestones: state.sort === DATE_OLDEST_TO_NEWEST ? sortOldest(upcoming_milestones) : sortNoteLatest(upcoming_milestones),
        currentMilestones:current_in_upcoming,
        pastMilestones: past_in_upcoming,
        pinnedMilestones: pin_in_upcoming
      };

    case SET_MILESTONES:
      const keys = Object.keys(payload.data);
      let newMilestone = state.milestones;

      keys.forEach((k) => {
        if (newMilestone.hasOwnProperty(k)) {
          const newList = newMilestone[k];
          payload.data[k].forEach((m) => {
            const milestone = state.milestones[k].filter(
              (om) => om.id === m.id && om.position_id === m.position_id
            );
            if (!milestone.length) {
              newList.push(m);
            }
          });
          newMilestone = { ...newMilestone, [k]: sortNoteLatest(newList) };
        } else {
          newMilestone = { ...newMilestone, [k]: sortNoteLatest(payload.data[k]) };
        }
      });
      console.trace(newMilestone);
      return {
        ...state,
        refresh: false,
        initialize: false,
        total: payload.total,
        milestones: newMilestone,
      };

    case SET_IS_FEATURED:
      return {
        ...state,
        refresh: true,
        featured: payload,
      };

    case SET_ORGANIZE_BY:
      return {
        ...state,
        refresh: true,
        organizeBy: payload,
        total:0,
      };

    case SET_JOB_ROLE:
      return {
        ...state,
        refresh: true,
        jobRole: payload,
        total:0,
      };

    case SET_CATEGORY:
      return {
        ...state,
        refresh: true,
        category: payload,
        total:0,
      };

    case SET_FILTERS:
      return {
        ...state,
        featured: payload.featured,
        organizeBy: payload.organizeBy,
        jobRole: payload.jobRole,
        category: payload.category,
        sort:payload.sort,
        customOrderJR:payload.customOrderJR,
        customOrderCAT:payload.customOrderCAT
      };

    case SET_SORT:
      return {
        ...state,
        refresh: true,
        sort: payload,
        total:0,
      };

    case SET_CUSTOMORDER_JR:
      return {
        ...state,
        refresh: true,
        customOrderJR: payload,
        total:0,
      };

    case SET_CUSTOMORDER_CAT:
      return {
        ...state,
        refresh: true,
        customOrderCAT: payload,
        total:0,
      };


    case CLEAR_FILTERS:
      return {
        ...state,
        refresh: true,
        initialize: false,
        organizeBy: null,
        jobRole: [],
        category: [],
        featured: false,
        sort:null,
        customOrderJR:[],
        customOrderCAT:[],
        total:0,
      };

    case ADD_MILESTONES:
      let current = [];
      let past = [];
      let upcoming =[];
      let pinned = [];
      let currentMilestones = state.currentMilestones;
      let pastMilestones = state.pastMilestones;
      let upcomingMilestones = state.upcomingMilestones;
      let pinnedMilestones = state.pinnedMilestones;

      let milestones = state.milestones;
      let currentMilestonesKeys = Object.keys(state.milestones);

      if (!state.organizeBy || state.organizeBy === DATE || state.organizeBy === DATE_NEWEST_TO_OLDEST) {
        let isAdd = false;

        if (!_.isEmpty(state.jobRole) || !_.isEmpty(state.category)) {
          // let positions = payload.data.positions.filter((p) => {
          //   if (
          //     (state.jobRole && state.jobRole === p.position.name) ||
          //     (state.category && state.category === p.position.name)
          //   ) {
          //     return true;
          //   }
          // });

          let positions = _.filter(payload.data.positions, (p) => {
            if (
              (state.jobRole && state.jobRole === p.position.name) ||
              (state.category && state.category === p.position.name)
            ) {
              return true;
            }
          });

          if (positions.length > 0) {
            isAdd = true;
          }
        } else {
          isAdd = true;
        }
        if (isAdd) {
          // if (
          //   moment().year() <= payload.data.start_year ||
          //   moment().year() <= payload.data.end_year ||
          //   payload.data.is_present
          // ) {
          //   payload.data.start_date = `${payload.data?.start_year}-${payload.data?.start_month || 12}-${payload.data?.start_day || 1}`
          //   current.push(payload.data);
          // } else {
          //   payload.data.start_date = `${payload.data?.start_year}-${payload.data?.start_month || 12}-${payload.data?.start_day || 1}`
          //   past.push(payload.data);
          // }
          payload.data.start_date = `${payload.data?.start_year}-${payload.data?.start_month || 12}-${payload.data?.start_day || 31}` 
          if(payload.data?.is_featured){
              pinned.push(payload.data);
          } else if (compareDate(payload.data) === 'upcoming') {
              upcoming.push(payload.data);
          } else if (compareDate(payload.data) === 'current') {
              current.push(payload.data);
          } else if (compareDate(payload.data) === 'past') {
              past.push(payload.data);
          }

          if (pinned.length > 0) {
            pinnedMilestones = [...pinned, ...pinnedMilestones];
            pinnedMilestones = pinnedMilestones.sort((a, b) => a.order - b.order);/**at the moment the sort here is newest to oldest date to all pinned group */
          } else if (upcoming.length > 0) {
            upcomingMilestones = [...upcoming, ...upcomingMilestones];
            // upcomingMilestones = upcomingMilestones.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
            upcomingMilestones = state.sort === DATE_OLDEST_TO_NEWEST ? sortOldest(upcomingMilestones) : sortNoteLatest(upcomingMilestones);
          }
          else if (current.length > 0) {
            currentMilestones = [...current, ...currentMilestones];
            // currentMilestones = currentMilestones.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
            currentMilestones = state.sort === DATE_OLDEST_TO_NEWEST ? sortOldest(currentMilestones) : sortNoteLatest(currentMilestones)
          } else if (past.length > 0) {
            pastMilestones = [...past, ...pastMilestones];
            // pastMilestones = pastMilestones.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
            pastMilestones = state.sort === DATE_OLDEST_TO_NEWEST ? sortOldest(pastMilestones) : sortNoteLatest(pastMilestones)

          }
        }
      } else {
        let notListedMilestones = [];

        payload.data.forEach((d) => {
          if (
            (state.jobRole && d.name !== state.jobRole) ||
            (state.category && d.category.name !== state.category)
          ) {
            return;
          }

          if (currentMilestonesKeys.indexOf(d.name) === -1) {
            notListedMilestones.push(d);
          } else {
            currentMilestonesKeys.forEach((k) => {
              if (k === d.name) {
                milestones[k] = [d, ...milestones[k]];
              }
            });
          }
        });

        notListedMilestones.forEach((nl) => {
          let list = [];
          if (currentMilestonesKeys.indexOf(nl.name) === -1) {
            currentMilestonesKeys.push(nl.name);
            list.push(nl);
          } else {
            list = milestones[nl.name];
            list.push(nl);
          }

          milestones[nl.name] = list;
        });
      }
      return {
        ...state,
        currentMilestones: currentMilestones,
        pastMilestones: pastMilestones,
        upcomingMilestones:upcomingMilestones,
        milestones: milestones,
        pinnedMilestones:pinnedMilestones
      };

    case UPDATE_CURRENT_MILESTONE:
      let currentMilestoneList = state.currentMilestones;
      let pin_milestones = state.pinnedMilestones;
      let upcoming_milestone_list = state.upcomingMilestones;
      let past_milestone_list = state.pastMilestones;
      state.currentMilestones.forEach((cm, index) => {
        if (cm.id === payload.data.id) {
          payload.data.start_date = `${payload.data?.start_year}-${payload.data?.start_month || 12}-${payload.data?.start_day || 31}`
          currentMilestoneList[index] = {
            ...cm,
            ...payload.data,
          };
        }
      });
      currentMilestoneList = currentMilestoneList.filter(pinned => pinned.is_featured === 0); //removed if unpinned the milestone in edit
      if(payload.data.is_featured === 1){ // I assumed that this is only 1 array since the return from response is object and converted to array.
        pin_milestones = [...pin_milestones, ...[payload.data]].sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
      }else{// when the date was changed and rearrange based on the event (upcoming,curren and past)
        if (compareDate(payload.data) === 'upcoming') {
          upcoming_milestone_list = [...upcoming_milestone_list, ...[payload.data]].sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
          currentMilestoneList = currentMilestoneList.filter(cm => cm.id !== payload.data.id);
        }  
        else if (compareDate(payload.data) === 'past') {
          currentMilestoneList = currentMilestoneList.filter(cm => cm.id !== payload.data.id);
          past_milestone_list = [...past_milestone_list, ...[payload.data]].sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
        }
      }
      return {
        ...state,
        currentMilestones: state.sort === DATE_OLDEST_TO_NEWEST ? sortOldest(currentMilestoneList) : sortNoteLatest(currentMilestoneList),
        upcomingMilestones:upcoming_milestone_list,
        pastMilestones: past_milestone_list,
        pinnedMilestones: pin_milestones
      };

    case UPDATE_PAST_MILESTONE:
      let pastMilestoneList = state.pastMilestones;
      let pin_past_milestones = state.pinnedMilestones;
      let current_in_past = state.currentMilestones;
      let upcoming_in_past = state.upcomingMilestones;
      
      state.pastMilestones.forEach((cm, index) => {
        if (cm.id === payload.data.id) {
          payload.data.start_date = `${payload.data?.start_year}-${payload.data?.start_month || 12}-${payload.data?.start_day || 31}`
          pastMilestoneList[index] = {
            ...cm,
            ...payload.data,
          };
        }
      });

      pastMilestoneList = pastMilestoneList.filter(pinned => pinned.is_featured === 0); //removed if unpinned the milestone in edit
      if(payload.data.is_featured === 1){
        pin_past_milestones = [...pin_past_milestones, ...[payload.data]];
      }else{// when the date was change and rearrange based on the event (upcoming,curren and past)
        if (compareDate(payload.data) === 'upcoming') {
          upcoming_in_past = [...upcoming_in_past, ...[payload.data]].sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
          pastMilestoneList = pastMilestoneList.filter(pm => pm.id !== payload.data.id);
        }  
        else if (compareDate(payload.data) === 'current') {
          pastMilestoneList = pastMilestoneList.filter(pm => pm.id !== payload.data.id);
          current_in_past = [...current_in_past, ...[payload.data]].sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
        }
      }

      return {
        ...state,
        pastMilestones: state.sort === DATE_OLDEST_TO_NEWEST ? sortOldest(pastMilestoneList) : sortNoteLatest(pastMilestoneList),
        currentMilestones:current_in_past,
        upcomingMilestones:upcoming_in_past,
        pinnedMilestones: pin_past_milestones
      };

    case UPDATE_FEATURED_MILESTONE:
      let featuredMilestone = state.featuredMilestone;

      if (state.organizeBy === JOB_ROLE) {
        for (let count = 0; count < payload.data.length; count++) {
          if (
            payload.data[count].position_id === featuredMilestone.position_id &&
            payload.data[count].id === featuredMilestone.id
          ) {
            featuredMilestone = payload.data[count];
            break;
          }
        }
      } else {
        if (state.featuredMilestone.id === payload.data.id) {
          featuredMilestone = payload.data;
        }
      }

      return {
        ...state,
        featuredMilestone: featuredMilestone,
      };

    case UPDATE_MILESTONES:
      let newMilestones = [];
      let milestonesList = state.milestones;
      let updatedFeaturedMilestone = state.featuredMilestone;
      let milestonesKeys = Object.keys(state.milestones);
      let notListedMilestones = [];

      if (state.featured) {
        for (let count = 0; count < payload.data.length; count++) {
          if (
            payload.data[count].id === state.featuredMilestone.id &&
            payload.data[count].position_id ===
              state.featuredMilestone.position_id
          ) {
            updatedFeaturedMilestone = {
              ...state.featuredMilestone,
              ...payload.data[count],
            };
            break;
          }
        }
      }

      milestonesKeys.forEach((m) => {
        let keyMilestones = [];

        state.milestones[m].forEach((km, index) => {
          // console.log('km: ', km);
          // console.log('Array.isArray(payload.data): ', Array.isArray(payload.data));
          if(Array.isArray(payload.data)) {
            for (let count = 0; count < payload.data.length; count++) {
              if (
                payload.data[count].id === km.id &&
                payload.data[count].position_id === km.position_id
              ) {
                milestonesList[m][index] = {
                  ...km,
                  ...payload.data[count],
                };
              }
            }

            // let exist = payload.data.filter((d) => {
            //   if (d.id === km.id) {
            //     if (d.name === m && d.position_id === km.position_id) {
            //       return true;
            //     }
            //   } else {
            //     return true;
            //   }
            // });

            let exist = _.filter(payload.data, (d) => {
              if (d?.id === km?.id) {
                if (d.name === m && d.position_id === km.position_id) {
                  return true;
                }
              } else {
                return true;
              }
            });

              if (exist.length > 0) {
                keyMilestones.push(milestonesList[m][index]);
              }
          } else {
            // console.log("Inside Non Array");
            // console.log('payload.data.id: ', payload.data.id);
            // console.log('km.id: ', km.id, '\n');
            if (
                payload.data.id === km.id 
                // && payload.data.position_id === km.position_id
              ) {
                milestonesList[m][index] = {
                  ...km,
                  ...payload.data,
                };
              }

              keyMilestones.push(milestonesList[m][index]);
          }
          
        });

        newMilestones = {
          ...newMilestones,
          [m]: keyMilestones,
        };
      });

      const payloadData = Array.isArray(payload.data) ? payload.data : [payload.data];

      payloadData.forEach((p) => {
        if (milestonesKeys.indexOf(p.name) === -1) {
          notListedMilestones.push(p);
        } else {
          milestonesKeys.forEach((m) => {
            if (m === p.name) {
              let exist = newMilestones[m].filter(
                (d) => d.id === p.id && d.position_id === p.position_id
              );

              if (!exist.length) {
                if (
                  (!state.jobRole || state.jobRole === p.name) &&
                  (!state.category || state.category === p.category?.name)
                ) {
                  newMilestones[m] = [p, ...newMilestones[m]];
                }
              }
            }
          });
        }
      });

      // update current milestones
      let updatedCurrentMilestones = state.currentMilestones.map(m => {
        const newData = payloadData.find(payload => payload.id === m.id);
        return newData || m;
      });

      notListedMilestones.forEach((nl) => {
        let list = [];
        if (milestonesKeys.indexOf(nl.name) === -1) {
          milestonesKeys.push(nl.name);
          list.push(nl);
        } else {
          list = newMilestones[nl.name];
          list.push(nl);
        }
        newMilestones[nl.name] = list;
      });

      return {
        ...state,
        milestones: newMilestones,
        featuredMilestone: updatedFeaturedMilestone,
        currentMilestones: updatedCurrentMilestones,
      };

    case DELETE_MILESTONE:
      // const udCurrentMilestoneList = state.currentMilestones.filter((cm) => {
      //   if (cm.id === payload.id) {
      //     if (cm.position_id !== payload.position_id) {
      //       return true;
      //     }
      //   } else {
      //     return true;
      //   }
      // });
      const udCurrentMilestoneList = _.filter(state.currentMilestones, (cm) => {
        if (cm.id === payload.id) {
          if (cm.position_id !== payload.position_id) {
            return true;
          }
        } else {
          return true;
        }
      });

      // const udPastMilestoneList = state.pastMilestones.filter((pm) => {
      //   if (pm.id === payload.id) {
      //     if (pm.position_id !== payload.position_id) {
      //       return true;
      //     }
      //   } else {
      //     return true;
      //   }
      // });

      //converted to git rid of the console log warning for eslint
      // the current code expect a returns but there are conditions that are not returning any
      const udPastMilestoneList = _.filter(state.pastMilestones, (pm) => {
        if (pm.id === payload.id) {
          if (pm.position_id !== payload.position_id) {
            return true;
          }
        } else {
          return true;
        }
      });

      const udUpcomingMilestoneList = _.filter(state.upcomingMilestones, (pm) => {
        if (pm.id === payload.id) {
          if (pm.position_id !== payload.position_id) {
            return true;
          }
        } else {
          return true;
        }
      });

      const udPinnedMilestoneList = _.filter(state.pinnedMilestones, (pm) => {
        if (pm.id === payload.id) {
          if (pm.position_id !== payload.position_id) {
            return true;
          }
        } else {
          return true;
        }
      });

      const udMilestonesKeys = Object.keys(state.milestones);
      let udMilestones = state.milestones;

      udMilestonesKeys.forEach((m) => {
        if (m === payload.name) {
          // let milestones = state.milestones[m].filter((d) => {
          //   if (d.id === payload.id) {
          //     if (d.position_id !== payload.position_id) {
          //       return true;
          //     }
          //   } else {
          //     return true;
          //   }
          // });
          let milestones = _.filter(state.milestones[m], (d) => {
            if (d.id === payload.id) {
              if (d.position_id !== payload.position_id) {
                return true;
              }
            } else {
              return true;
            }
          });

          udMilestones = {
            ...udMilestones,
            [m]: milestones,
          };
        }
      });

      return {
        ...state,
        currentMilestones: udCurrentMilestoneList,
        pastMilestones: udPastMilestoneList,
        upcomingMilestones:udUpcomingMilestoneList,
        pinnedMilestones:udPinnedMilestoneList,
        milestones: udMilestones,
      };

    case DELETE_MILESTONE_ORG:
      const milestoneId = payload.id;
      let updatedMilestones = { ...state.milestones };

      Object.keys(updatedMilestones).forEach((k) => {
          updatedMilestones[k] = updatedMilestones[k].filter(
              (m) => m.id !== milestoneId
          );

          // Optional: remove the key entirely if the group becomes empty
          if (updatedMilestones[k].length === 0) {
              delete updatedMilestones[k];
          }
      });

      return {
          ...state,
          milestones: updatedMilestones,
      };
    
    case SET_PLAY_MUSIC:
        return {
          ...state,
          playMusic: payload
        };

    case SET_MILESTONES_SEARCHTEXT:
      return {
        ...state,
        refresh: true,
        milestonesSearchtext: payload,
      };
    
    case SET_LOADING_TRANSLATE:
      return {
        ...state,
        loadingTranslate: payload,
      };

    case SET_BUTTON_COUNT:
      return {
        ...state,
        buttonCount: payload ?? 0,
      };

    default:
      return state;
  }
};

export default reducer;
